import { template as template_417dd92327864ba5b2a7b82e2ccb3fd0 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import { isPresent } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
export default class TextFieldFilter extends Component {
    @service
    intl;
    @tracked
    isDisplayed;
    constructor(){
        super(...arguments);
        this.args.initParam(this.args.key, this.args.value);
        this.isDisplayed = isPresent(this.args.value);
    }
    searchTagTextField = ()=>{
        const label = this.intl.t(`controls.criteria.${this.args.key}`);
        return isPresent(this.args.value) ? `${label}: "${this.args.value}"` : null;
    };
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    onChange = (value)=>{
        this.args.updateParam(this.args.key, value);
    };
    get getValue() {
        return this.args.getParam(this.args.key);
    }
    clear = ()=>{
        this.args.updateParam(this.args.key, null);
    };
    static{
        template_417dd92327864ba5b2a7b82e2ccb3fd0(`
    <Portal @target="filter-fields">
      <FilterWrapper
        @form={{@form}}
        @label="controls.criteria.{{@key}}"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.getValue}}
        @clear={{this.clear}}
        ...attributes
      >
        <@form.element
          @size="sm"
          @class="bg-gray-100"
          @model={{this}}
          @onChange={{this.onChange}}
          @value={{this.getValue}}
        />
      </FilterWrapper>
    </Portal>

    <Portal @target="search-badge-tags">
      <SearchTag
        class='textfield'
        @isDisplayed={{isPresent @value}}
        @text={{this.searchTagTextField}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
